<template>
  <v-row no-gutters>
    <!-- <v-col cols="12" class="text-center">
      <input type="button" value="Say hello" @click="showAndroidToast()" style="width: 80%; height: 40px; border: 1px solid black; margin: 12px;" />
    </v-col> -->
    <div class="loginGuideSection ng-info-card" v-if="showLoginGuide">
      <span class="ng-info-icon" aria-hidden="true"><v-icon size="20" color="#5A00B4">mdi-play-circle-outline</v-icon></span>
      <p class="ng-info-text">
        {{ $t(`label.loginGuide`) }} {{ $t(`label.clickThis`) }}
        <a href="https://ng88.wistia.com/s/puer0uud0qw0woj" target="_blank" rel="noopener" class="linkText">{{ $t(`label.link`) }}</a>
        {{ $t(`label.watchVideo`) }}
      </p>
      <button type="button" class="ng-info-close" aria-label="Close" @click="closeShowLoginGuide()">
        <v-icon size="18" color="#5B6080">mdi-close</v-icon>
      </button>
    </div>
    <v-col cols="12" :class="$vuetify.breakpoint.mdAndDown ? 'login_panel px-3' : 'login_panel px-12 py-8'">
      <v-form ref="loginForm">
        <app-form-field
          :enabledLabel="true"
          v-model.trim="loginObj.memberCode"
          :label="$t(`field.username`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.usernameRules()"
          prependInnerIcon="mdi-account-outline"
        ></app-form-field>
        <app-form-field
          :enabledLabel="true"
          v-model.trim="loginObj.password"
          :label="$t(`field.password`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.passwordRules()"
          :allowShowPassword="true"
          type="password"
          prependInnerIcon="mdi-lock-outline"
        ></app-form-field>
        <v-row no-gutters>
          <v-col cols="12" class="text-right forgot-password">
            <v-btn text height="auto" @click="openForgotPasswordDialog" class="text-capitalize pr-0">
              {{ $t(`label.forgotPassword`) }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- <app-button :action="this.login" :title="$t(`button.login`)"></app-button> -->
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn height="auto" @click="this.login" class="button-primary full-width font-weight-bold">
              {{ $t(`button.login`) }}
            </v-btn>
            <!-- <button-primary
                :title="$t('button.login')"
                @action="this.login"
                :customClass="'full-width font-weight-bold'">
            </button-primary> -->
          </v-col>
          <v-col cols="12" class="text-center">
            <p v-show="loginErrorMsg" class="ng-form-error" role="alert">{{ loginErrorMsg }}</p>
            <p v-show="ssoLoginErrMsg" class="ng-form-error" role="alert">{{ ssoLoginErrMsg }}</p>
          </v-col>
        </v-row>
      </v-form>
      <div class="ng-signup-row">
        <span class="ng-divider-text">{{ $t(`message.dontHaveAccount`) }}</span>
        <button type="button" class="ng-btn-outline" @click="openRegister">{{ $t(`label.signUp`) }}</button>
      </div>
      <v-col cols="12">
        <telegram-login-button @openRegister="openRegister" @login="login" @error="telegramLoginError"></telegram-login-button>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import stingFormat from 'string-format'
import { formValidator, uiHelper, errorCodeHelper } from '@/util'
import { SESSION, SHARED } from '@/constants/constants'
import { getAdClickParams } from '@/util/ad-click-helper'
import { MEMBER_LOGIN } from '@/store/member.module'
import { ROUTE_NAME } from '../../constants/route.constants'
import telegramLoginButton from '@/components/member/telegramLoginButton'
import { RESET_SSO_LOGIN, RESET_SSO_VERIFY_ERROR } from '@/store/sso-auth.module'

export default {
  name: 'appLogin',
  components: { telegramLoginButton },
  mounted() {
    this.$refs.loginForm.reset()
    this.attemptSsoLogin()
  },
  props: {
    closeAction: {
      type: Function,
      required: true,
      default: () => {}
    },
    openRegisterDialog: {
      type: Function,
      required: true,
      default: () => {}
    },
    openForgotPasswordDialog: {
      type: Function,
      required: true,
      default: () => {}
    },
    loginErrorMsg: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: () => ({
    showLoginGuide: true,
    validator: formValidator,
    stingFormat: stingFormat,
    retainSignIn: false,
    loginObj: {
      memberCode: '',
      password: '',
      domain: '',
      platform: '',
      option: SHARED.DEFAULT_LOGIN_PASSWORD_METHOD,
      fp: '',

      // For SSO login
      loginKey: '',
      fbPixelId: '',
      fbp: uiHelper.getCookie(SESSION.FB_P),
      fbc: uiHelper.getCookie(SESSION.FB_C),
      s2: uiHelper.getCookie(SESSION.UTM_S2)
    },
    ssoLoginErrMsgTimer: null,
    ssoLoginErrMsg: null
  }),
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    ssoLoginKey() {
      return this.$store.state.ssoAuth.ssoLoginData.loginKey
    },
    ssoVerifyError() {
      return this.$store.state.ssoAuth.ssoVerifyError.complete
    }
  },
  watch: {
    isLoggedIn() {
      this.$refs.loginForm.reset()
      uiHelper.removeCookie(SESSION.AFF_CODE)
      uiHelper.removeCookie(SESSION.REFER_CODE)
      uiHelper.removeCookie(SESSION.UTM_S2)
    },
    ssoLoginKey() {
      if (this.$store.state.ssoAuth.ssoLoginData.loginKey) {
        this.attemptSsoLogin()
      }
    },
    ssoVerifyError() {
      if (this.$store.state.ssoAuth.ssoVerifyError.complete) {
        const ssoVerifyError = this.$store.state.ssoAuth.ssoVerifyError
        this.ssoLoginErrMsg = ssoVerifyError.error
        this.$store.dispatch(`${RESET_SSO_VERIFY_ERROR}`)

        setTimeout(() => {
          this.ssoLoginErrMsg = ''
        }, 5000)
      }
    }
  },
  methods: {
    closeShowLoginGuide() {
      this.showLoginGuide = false
    },
    // showAndroidToast() {
    //   // AndroidFunction.isAndroid();
    //   // AndroidFunction.isMobile();
    //     // Android.showToast(toast);
    //     // Android.biometric();
    // },
    attemptSsoLogin() {
      if (!this.$store.state.ssoAuth.ssoLoginData.loginKey) {
        return
      }
      // Handle existing telegram user login
      // Add some delay to properly dismiss loading indicator first (300ms to dismiss)
      // Before fire login API
      const data = this.$store.state.ssoAuth.ssoLoginData
      const ssoLogin = {
        membercode: data.membercode,
        loginKey: data.loginKey
      }

      setTimeout(() => {
        this.login({ ssoLogin })
      }, 350)

      this.$store.dispatch(`${RESET_SSO_LOGIN}`)
    },
    telegramLoginError(error) {
      this.ssoLoginErrMsg = error

      if (this.ssoLoginErrMsgTimer) {
        clearTimeout(this.ssoLoginErrMsgTimer)
      }
      this.ssoLoginErrMsgTimer = setTimeout(() => {
        this.ssoLoginErrMsg = ''
      }, 5000)
    },
    openRegister() {
      this.$refs.loginForm.reset()
      this.closeAction()
      this.$router.push({ name: ROUTE_NAME.REGISTER, params: { lang: this.$route.params.lang } })
    },
    login({ ssoLogin } = {}) {
      // ssoLogin = { loginKey, membercode }
      // Custom SSO login will have no username/password, no need validate form
      if (ssoLogin || this.$refs.loginForm.validate()) {
        let jObj = this
        this.loginObj.domain = uiHelper.getHostname() + '/'
        this.loginObj.platform = uiHelper.getPlatform()
        this.loginObj.language = uiHelper.getLanguage()
        this.loginObj.fbPixelId = uiHelper.getCookie(SESSION.FB_PIXEL_CODE)
        this.loginObj.fbp = uiHelper.getCookie(SESSION.FB_P)
        this.loginObj.fbc = uiHelper.getCookie(SESSION.FB_C)
        // ad channel, landing URL and click id of the latest ad click
        Object.assign(this.loginObj, getAdClickParams())
        this.loginObj.s2 = uiHelper.getCookie(SESSION.UTM_S2)

        // Create a separate object to store SSO login information
        // Update this.loginObj values will cause UI form field change
        const ssoParameters = {}
        if (ssoLogin) {
          if (ssoLogin.loginKey) {
            ssoParameters.loginKey = ssoLogin.loginKey
          }
          if (ssoLogin.membercode) {
            ssoParameters.memberCode = ssoLogin.membercode
          }
        }

        let existFp = typeof uiHelper.getCookie('fp_visitor') != 'undefined' && uiHelper.getCookie('fp_visitor') != null && uiHelper.getCookie('fp_visitor') != ''
        if (existFp) {
          jObj.loginObj.fp = uiHelper.getCookie('fp_visitor')
          let loginObj = { ...this.loginObj, ...ssoParameters }
          this.$store.dispatch(`${MEMBER_LOGIN}`, {
            loginObj
          })
        } else {
          try {
            jObj.loginObj.fp = uiHelper.getFingerprints()
            if (jObj.loginObj.fp != '' && jObj.loginObj.fp != null) {
              uiHelper.setCookie('fp_visitor', jObj.loginObj.fp, 30)
              let loginObj = { ...jObj.loginObj, ...ssoParameters }
              this.$store.dispatch(`${MEMBER_LOGIN}`, {
                loginObj
              })
            }
          } catch (err) {
            console.log(err)
            let loginObj = this.loginObj
            this.$store.dispatch(`${MEMBER_LOGIN}`, {
              loginObj
            })
          }
        }
        // let loginObj = this.loginObj
        // this.$store.dispatch(`${MEMBER_LOGIN}`, {
        //   loginObj
        // })
        try {
          srtmCommands.push({
            event: 'track.user.login',
            payload: {
              action: 'complete',
              userId: this.loginObj.memberCode
            }
          })
          console.log('Sport Radar Login Completed!')
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
}
</script>

<style lang="scss">
// Soft info notice, shared with the /register page
.loginGuideSection.ng-info-card {
  width: calc(100% - 40px);
  margin: 16px 20px 0;
}

.ng-info-card {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 8px 12px 12px;
  border-radius: var(--ng-radius-md);
  background: #f1efff;
  border: 1px solid #e0d9ff;

  .ng-info-icon {
    flex: none;
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ng-info-text {
    flex: 1 1 auto;
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
    color: var(--ng-text);
  }

  .ng-info-close {
    flex: none;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: rgba(18, 23, 52, 0.06);
    }
  }
}
.linkText {
  color: var(--ng-violet) !important;
  font-family: var(--ng-font-bold);
  text-decoration: underline;
}
// .v-dialog prefix so this beats the px-3 / px-12 utility classes on the panel
.v-dialog .login_panel,
.login_panel {
  color: var(--ng-text);
  background-color: #ffffff;
  padding: 20px 24px 8px !important;

  .ng-form-error {
    margin: 10px 0 0;
    padding: 8px 12px;
    border-radius: 10px;
    background: #fff0f0;
    color: #c62828;
    font-size: 13px;
  }

  .ng-signup-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
  }

  .dialog-header {
    background-color: var(--v-primary-base);
  }

  .link-underscore:hover {
    text-decoration: underline;
    color: var(--v-primary-base);
  }

  .forgot-password {
    margin: 4px 0 16px;

    .v-btn,
    .theme--dark.v-btn {
      color: var(--ng-violet);
      font-family: var(--ng-font-bold);
      font-size: 13px;
      letter-spacing: 0;
    }

    .v-btn:hover {
      text-decoration: underline;
      color: var(--ng-royal);
      cursor: pointer;
    }

    .v-btn::before {
      background-color: unset;
    }
  }
}
</style>
